import * as React from 'react';
import { lazy } from 'react';
import type { RouteProps } from 'react-router-dom';

const Mobile = lazy(() => import('./index'));

/** 路由配置 */
export const routeConfig: RouteProps[] = [
  {
    path: '/mobile',
    element: <Mobile />,
  },
];
